import { render, staticRenderFns } from "./suporte-personificar.vue?vue&type=template&id=7679a6be&scoped=true"
import script from "./suporte-personificar.vue?vue&type=script&lang=ts"
export * from "./suporte-personificar.vue?vue&type=script&lang=ts"
import style0 from "./suporte-personificar.vue?vue&type=style&index=0&id=7679a6be&prod&scoped=true&lang=css"
import style1 from "./suporte-personificar.vue?vue&type=style&index=1&id=7679a6be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7679a6be",
  null
  
)

export default component.exports